// extracted by mini-css-extract-plugin
export default {"topRight4":"XRsemcGCHrTDo8Dfsn9g","minHeight":"szTagSrQl9Az5BiBYgDL"};